import { render, staticRenderFns } from "./CustomsDeclarationOutInfo.vue?vue&type=template&id=04d2de59&scoped=true"
import script from "./CustomsDeclarationOutInfo.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationOutInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomsDeclarationOutInfo.vue?vue&type=style&index=0&id=04d2de59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2de59",
  null
  
)

export default component.exports